module.exports = __webpack_public_path__ + "img/step2_img.247d7778.png";